/**
 * O `socket_id` da presença web e o caminho de uma página sem query string.
 *
 * - **Um identificador por browser e fonte**, guardado no `localStorage`. O servidor separa as
 *   sessões por ele: a da web não se funde com a da app do mesmo administrador, e a saída de um
 *   não fecha a do outro. Os separadores do mesmo browser partilham-no — fechar um de dois não
 *   parte a sessão, e um F5 retoma-a (a saída espera 2 minutos por um sinal do mesmo socket).
 * - **Sem query string**: o URL de uma página levava os termos de pesquisa de quem trabalha para o
 *   histórico de páginas (A19).
 */
let emMemoria: Record<string, string> = {};

export function socketIdDaWeb(fonteCodigo: string): string {
    const chave = `monitoramento_socket_${fonteCodigo}`;

    try {
        const guardado = window.localStorage.getItem(chave);
        if (guardado) return guardado;

        const novo = `web-${gerar()}`;
        window.localStorage.setItem(chave, novo);
        return novo;
    } catch {
        // Sem localStorage (janela privada, bloqueio): um por carregamento da página.
        emMemoria[chave] ??= `web-${gerar()}`;
        return emMemoria[chave];
    }
}

export function caminhoSemQuery(url: string): string {
    try {
        return new URL(url, window.location.origin).pathname;
    } catch {
        return url.split(/[?#]/)[0] || "/";
    }
}

function gerar(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
